export type ProfileMenuItem = 'Icon' | 'Profile' | 'Language' | 'Logout';

export const ProfileMenuItem = {
  Icon: 'Icon' as ProfileMenuItem,
  Profile: 'Profile' as ProfileMenuItem,
  ChangePassword: 'Change Password' as ProfileMenuItem,
  Language: 'Language' as ProfileMenuItem,
  Logout: 'Logout' as ProfileMenuItem,
};
